import styled from "styled-components";
import {BackTableField, PHP_TYPE_MAP, PhpType} from "../../../features/schemaManageSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import hljs from "highlight.js/lib/core";
import React from "react";
import {headerTypesIcons, schemas} from "../../../config";
import {Field, FIELD_TYPE_INFO} from "../../../Types";
import {FontAwesomeTypeIcon} from "../../misc/TypeIcon";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";
import {faCheck, faQuestion, faTriangleExclamation, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SqlQuery} from "./BackTableFieldViewTable";

interface BackTableFieldPropsI {
    tableName: string,
    fieldKey: string,
    index: number,
}

type FieldItemTypeU = "static" | "ethereal" | "other";

type FieldItemViewPropsI = {
    fieldKey: string,
    index: number,
    type: FieldItemTypeU,
    editable?: boolean,
    fieldSchema?: Field,
};

export default function BackTableNullsViewTable({tableName, fields}: {
    tableName: string,
    fields: string[];
}) {

    return <Container>
        <table>
            <thead>
            <tr>
                <th></th>
                <th>Поле/ключ</th>
                <th>Фронт тип</th>
                <th>На фронті</th>
                <th>#</th>
            </tr>
            </thead>
            <tbody>
            {fields.map((key, i) =>
                <BackTableNullView tableName={tableName} key={key} index={i} fieldKey={key}/>)}
            </tbody>
        </table>

    </Container>
}

function BackTableNullView({
                               tableName,
                               fieldKey,
                               index,
                           }: BackTableFieldPropsI) {

    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const staticNulls = staticTable !== null && staticTable.nullableFields?.find(x => x === fieldKey)
    const etherealTable = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const etherealNulls = etherealTable !== null && etherealTable.nullableFields?.find(x => x === fieldKey)
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const project = useAppSelector(state => state.project.name);

    const fields: Field[] | undefined = schemas[project].tables[tableName]?.fields;
    const dispatch = useAppDispatch();

    let fieldSchema = fields && fields.find((v) => v.key === fieldKey)

    return <>
        {mode === "edit" && staticNulls &&
            <NullItemView fieldSchema={fieldSchema} type={"static"} fieldKey={fieldKey}
                          index={index}/>}
        {mode === "edit" && etherealNulls &&
            <NullItemView fieldSchema={fieldSchema} type={"ethereal"} fieldKey={fieldKey}
                          index={index}/>}
        {mode === "view" &&
            <NullItemView fieldSchema={fieldSchema} type={"other"} editable fieldKey={fieldKey}
                          index={index}/>}
    </>
}


function NullItemView({
                          index,
                          fieldKey,
                          type,
                          editable = false,
                          fieldSchema,
                      }: FieldItemViewPropsI) {

    return <>
        <tr className={"title"}>
            <td className="icon">
                {fieldSchema && <FontAwesomeTypeIcon className={'fa-color-text'} type={fieldSchema.type}/>}
                {!fieldSchema && <FontAwesomeIcon className={'fa-color-text'} icon={faQuestion}/>}
            </td>
            <td className={'key'}>
                {fieldKey}
            </td>
            <td className="content">
                {fieldSchema && <span style={{
                    background: FIELD_TYPE_INFO[fieldSchema.type].color,
                    color: getReadableTextColor(FIELD_TYPE_INFO[fieldSchema.type].color)
                }} className={"front-type"}>{headerTypesIcons[fieldSchema.type].alt}</span>}
            </td>
            <td className="present">
                <FontAwesomeIcon size={"lg"} className={fieldSchema?.editable ? 'fa-color' : 'fa-yellow'}
                                 icon={fieldSchema?.editable ? faCheck : faXmark}/>
            </td>
            <td className={"index"}>{type === "static" && <i>STATIC |&nbsp;</i>}{index + 1}</td>
        </tr>
    </>
}


const Container = styled.div`
    //display: flex;
    //flex-direction: column;
    //gap: .5rem;
    width: 100%;
    //max-width: 100%;
    padding: .4rem;
    border-radius: .2rem;
    background-color: var(--table-header-bg-color);
    //border-collapse: separate;
    overflow-x: auto;

    table {
        table-layout: auto;
        width: 100%;
        border: 1px solid var(--table-border-color);

        th, td {
            vertical-align: middle;
            padding: .4rem .2rem;
            line-height: 1.2;
            border: 2px solid var(--table-border-color);
        }

        th {
            text-align: center;
            white-space: nowrap;
        }
    }

    tbody {
        max-width: 100%;
        overflow-x: auto;

        & > tr {
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        }

    }

    .php-type {
        padding: .2rem .4rem;
        border-radius: .2rem;
        width: 100%;
        white-space: nowrap;
        display: inline-block;
    }

    .icon {

        width: 1%;
        text-align: center;
    }

    .present {
        text-align: center;
        width: 1%;
    }

    .content {
        width: 50%;
    }

    .title {
        line-height: 1;

        .key {
            width: 1%;
            text-align: left;
            white-space: nowrap;
            padding-right: .4rem;
            padding-left: .4rem;
        }

        .front-type {
            padding: .2rem .4rem;
            border-radius: .2rem;
            //width: fit-content;
            width: 100%;
            white-space: nowrap;
            display: inline-block;
            //height: 3rem;
            //width: 100%;
        }

    }

    .index {
        min-width: 30px;
        width: 1%;
        text-align: center;
        white-space: nowrap;
    }

`;
